import {Directive, ElementRef, EventEmitter, HostListener, Input, Optional, Output, ViewChild} from '@angular/core';
import {avoidLoginCharacters, avoidPassCharacters, restrictChar, restrictSingleQuote, restrictXml} from "../common";
import {FormControl, NgControl} from "@angular/forms";
import {isUndefined} from "lodash";

@Directive({
    selector: '[inputrestriction]'
})
export class InputRestrictionDirective {

    @Input('inputrestriction') InputRestriction: string;

    @Input('opts') options: 'restrictSingleQuote' | 'restrictXml' | 'password' | 'login';

    @Output() invalidCharacter = new EventEmitter<any>();

    @ViewChild("input") myFormControl: FormControl;

    private element: ElementRef;
    private readonly ngControl;

    // constructor(element: ElementRef, private ddd: DynamicFormComponent, private fc: NgControl) {
    constructor(element: ElementRef, @Optional() fc: NgControl) {
        this.ngControl = fc;
        this.element = element;
    }

    @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
        this.pasteValidation(event);
    }

    @HostListener('keypress', ['$event'])
    keyPressValidation(event: KeyboardEvent) {
        if (restrictChar(event, this.InputRestriction)) {
            return true;
        }
        this.invalidCharacter.emit({options: this.options, restriction: this.InputRestriction});
        event.preventDefault();
        return false;
    }

    pasteValidation(event) {
        setTimeout(() => {
            if (!this.element.nativeElement || !this.element.nativeElement.value) return;
            if (this.ngControl) {
                switch (this.options) {
                    case 'restrictXml': {
                        const clean = restrictXml(this.element.nativeElement.value);
                        this.ngControl.control.patchValue(clean, {emitEvent: true});
                        break;
                    }
                    case 'login': {
                        const invalidCharacters = avoidLoginCharacters(false);
                        const f = invalidCharacters.find((char) => {
                            return this.element.nativeElement.value.indexOf(char) > -1;
                        });
                        if (!isUndefined(f)) {
                            this.invalidCharacter.emit({options: this.options, restriction: this.InputRestriction});
                            this.ngControl.control.patchValue('', {emitEvent: true});
                            break;
                        }
                        break;
                    }
                    case 'password': {
                        const invalidCharacters = avoidPassCharacters(false);
                        const f = invalidCharacters.find((char) => {
                            return this.element.nativeElement.value.indexOf(char) > -1;
                        });
                        if (!isUndefined(f)) {
                            this.invalidCharacter.emit({options: this.options, restriction: this.InputRestriction});
                            this.ngControl.control.patchValue('', {emitEvent: true});
                            break;
                        }
                        break;
                    }
                    default: {
                        const clean = restrictSingleQuote(this.element.nativeElement.value);
                        this.ngControl.control.patchValue(clean, {emitEvent: true});
                    }
                }
            } else {
                this.element.nativeElement.value = restrictSingleQuote(this.element.nativeElement.value);
            }
        }, 33);
    }
}

// public restrictNumeric(e): boolean {
// no carriage return screws up scene item tree and no single quote ' screws up scene save
// return restrictChar(e, 'basic');

// if (e.which === 13) return false; // no carriage return screws up scene item tree
// if (e.which === 39) return false; // no single quote ' screws up scene save
// return true;

// let input;
// if (e.metaKey || e.ctrlKey) {
//   return true;
// }
// if (e.which === 32) {
//   return false;
// }
// if (e.which === 0) {
//   return true;
// }
// if (e.which < 33) {
//   return true;
// }
// if (e.which === 97)
//   return true;
// return false;
// const txt = String.fromCharCode(e.which);
// const a = txt.replace(/\r?\n|\r/g, "");
// return  a;
// return !!/[\d\s]/.test(input);
// }


// var regex = new RegExp(this.InputRestriction);
// var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
// if (regex.test(str)) {
//   return true;
// }
